export default __webpack_public_path__ + "static/media/icon-card-payment.bcd46b47.svg";